import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import "moment/locale/si";
import { fontSize } from "@mui/system";

const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '16px',
    background: '#fff',
};

const thTdStyle = {
    border: '1px solid #ccc',
    padding: '4px',
    textAlign: 'center',
};

const tdTdStyle = {
    border: '1px solid #ccc',
    padding: '4px',
    textAlign: 'left',
    fontSize: '14px',
};

function EtashtakaTable({ erashtakaRecords }) {
    moment.locale("si");
    return (
        <div>
            <div style={{ textAlign: 'left', margin: '24px 0 12px 0', fontWeight: 'bold', fontSize: '0.8em' }}>
                ඒරාෂ්ටක
            </div>
            <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={thTdStyle}>ඒරාෂ්ටකය</th>
                        <th style={thTdStyle}>සිට</th>
                        <th style={thTdStyle}>දක්වා</th>
                        <th style={thTdStyle}>කාල පරාසය</th>
                    </tr>
                </thead>
                <tbody>
                    {erashtakaRecords.map((row, idx) => (
                        <tr key={idx}>
                            <td style={tdTdStyle}>{row.name}</td>
                            <td style={tdTdStyle}>{moment(new Date(row.from)).format('YYYY - MMMM - DD')}</td>
                            <td style={tdTdStyle}>{moment(new Date(row.to)).format('YYYY - MMMM - DD')}</td>
                            <td style={tdTdStyle}>{row.duration}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
    EtashtakaTable.propTypes = {
        erashtakaRecords: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                from: PropTypes.string.isRequired,
                to: PropTypes.string.isRequired,
                duration: PropTypes.string.isRequired,
            })
        ).isRequired,
    };
}

export default EtashtakaTable;